import { Component, inject, ViewChild,
    ChangeDetectionStrategy
} from '@angular/core';
import { AdminBaseEditComponent } from "src/modules/sm-base/components/admin-base-edit/admin-base-edit.component";
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { ProjectPlanningTools } from "../../models/project-planning-tools.model";
import { CalendarEventTemplate } from '../../netgen/CalendarEventTemplate';
import { CalendarOutlineLevel } from '../../netgen/CalendarOutlineLevel';
import { CalendarOutlineTemplate } from '../../netgen/CalendarOutlineTemplate';
import { ProjectPlanningService } from '../../services/project-planning.service';
import { EditCalendarOutlineTemplateTableComponent } from '../edit-calendar-outline-template-table/edit-calendar-outline-template-table.component';

@Component({
    selector: 'app-edit-calendar-outline-template',
    templateUrl: './edit-calendar-outline-template.component.html',
    styleUrl: './edit-calendar-outline-template.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditCalendarOutlineTemplateComponent extends AdminBaseEditComponent<CalendarOutlineTemplate> {

    service = inject(ProjectPlanningService);

    definition = ProjectPlanningTools.definitionCalendarOutlineTemplate;

    outlineLevels: CalendarOutlineLevel[];
    eventTemplates: CalendarEventTemplate[];

    @ViewChild("table")
    table: EditCalendarOutlineTemplateTableComponent;

    getForm(): FrontendForm {
        return this.app.tForm("entity.CalendarOutlineTemplate.fields", new FrontendForm([
            new FrontendField("title", "", FrontendFieldType.string, { mandatory: true }),
            new FrontendField("description", "", FrontendFieldType.textArea, { fixedHeight: "100px" })                   
        ]));
    }

    async initAdditionalData(): Promise<void> {
        this.outlineLevels = await this.service.getOutlineLevels();
        this.eventTemplates = await ProjectPlanningTools.definitionCalendarEventTemplate.loadDataHandlerList(this.app, this);

        this.item.structurePaths ??= [];
        this.item.events ??= [];
        for (let e of this.item.events) {
            e.template = this.eventTemplates.find(t => t.id == e.templateId);
        }

        this.table.init(this.item, this.eventTemplates, this.outlineLevels, await this.service.getOutlineTemplates(), await this.service.getEventTypes(), await this.service.getRoles(), false);
    }

    validateForm(_: string): boolean {
        return this.app.validateForm(this.form, this.table != null ? () => this.table.validate() : null);
    }

}
